export default "__VITE_ASSET__Bhfk2y7A__"